import { getState, setState } from "../../utils/localStorage";
import * as types from "../actions/types/onboarding.types";

const initialState = {
    isValidateLoading: false,
    token: "ABC",
    errorMessage: null,
    isValidateSuccessful: false,
    isValidateFailed: false,
    validateState: "",
    isTokenAuthLoading: false,
    isTokenSuccessful: false,
    isTokenFailed: false,
    tokenLoadingState: "idle",
    errorTokenMessage: "",
    validateTokenState: {},
    isPasswordLoading: false,
    isPasswordSuccessful: false,
    isPasswordFailed: false,
    errorPasswordMessage: null,
    user: {
        docs: {
            residentPermitFileUrl: "",
            utilityBillFileUrl: "",
            businessUtilityBillFileUrl: ""
        },
        updateFlag: "none",
        country: "Nigeria"
    },
    fetchAccountState: "idle",
    userAccounts: null, // this is an array (objects) of all the accounts associated with a user
    errorAccountMessage: null,
    selectedAccount: {}, // an object that holds the data of the current selected account
    createAccSuccessMsg: "",
    userDocsInfo: {},
    isAuthenticated: false,
    loginStatus: "initial",
    loginErrorMsg: "",
    smeEmail: "",
    smeAccounts: [],
    isBeingOnboarded: false,
    showAccountSetupModal: false,
    showPasswordSetModal: false,
    fetchSmeState: "initial",
    validateKycState: "idle",
    kycData: {
        tin: "",
        cac: "",
        company: "",
        email: "",
        address: "",
        registrationDate: "",
        secretary: "",
        branchOffice: "",
        lga: "",
        objectives: "",
        activity: "",
        registrationNo: "",
        city: "",
        name: "",
        shareholders: "",
        typeofEntity: "",
        directors: "",
        state: "",
        headOffice: "",
        country: "",
    },
    kycErrorModal: false,
    uploadFileState: "idle",
    isAccountSetup: false,
    newAccountDetails: {},
    selectedAccountType: "",
    homeState: "idle",
    businessUserExists: false,
    fromConfirmAccount: false,
    signupToken: "",
    signupEmail: "",
    fromInvitePage: false,
    ntbEmail: "",
    ntbPassword: "",
};

export const signupReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_USER_ACCOUNT_CHOICE:
            return {
                ...state,
                user: { ...state.user, accountChoice: action.payload },
            };
        case types.VALIDATE_USER_STARTED:
            return {
                ...state,
                isValidateLoading: true,
            };
        case types.VALIDATE_USER_SUCCEEDED:
            return {
                ...state,
                isValidateLoading: false,
                isValidateSuccessful: true,
                signupEmail: action.payload.email,
            };
        case types.VALIDATE_USER_FAILED:
            return {
                ...state,
                isValidateLoading: false,
                errorMessage: action.payload,
                isValidateFailed: true,
            };
        case types.RESET_VALIDATE_USER:
            return {
                ...state,
                isValidateSuccessful: false,
                isValidateFailed: false,
                errorMessage: null,
            };
        case types.VALIDATE_TOKEN_STARTED:
            return {
                ...state,
                tokenLoadingState: "loading",
            };
        case types.VALIDATE_TOKEN_SUCCEEDED:
            return {
                ...state,
                tokenLoadingState: "success",
                validateState: "confirmed",
            };
        case types.VALIDATE_TOKEN_FAILED:
            return {
                ...state,
                tokenLoadingState: "failed",
                errorTokenMessage: action.payload,
            };
        case types.CHANGE_VALIDATION_STATE:
            return {
                ...state,
                validateState: action.payload,
            };
        case types.CREATE_NEW_PASSWORD_STARTED:
            return {
                ...state,
                isPasswordLoading: true,
            };
        case types.CREATE_NEW_PASSWORD_SUCEEDED:
            return {
                ...state,
                isPasswordLoading: false,
                isPasswordSuccessful: true,
                user: { ...state.user, userID: action.payload.userID },
            };
        case types.CREATE_NEW_PASSWORD_FAILED:
            return {
                ...state,
                isPasswordLoading: false,
                isPasswordFailed: true,
                errorPasswordMessage: action.payload,
            };
        case types.STORE_EMAIL:
            return {
                ...state,
                user: { ...state.user, email: action.payload },
            };
        case types.STORE_BUSINESS_TYPE:
            return {
                ...state,
                user: { ...state.user, businessType: action.payload },
            };
        case types.STORE_FIRST_NAME:
            return {
                ...state,
                user: { ...state.user, firstName: action.payload },
            };
        case types.STORE_MIDDLE_NAME:
            return {
                ...state,
                user: { ...state.user, middleName: action.payload },
            };
        case types.STORE_LAST_NAME:
            return {
                ...state,
                user: { ...state.user, lastName: action.payload },
            };
        case types.FETCH_USER_ACCOUNTS_STARTED:
            return {
                ...state,
                fetchAccountState: "loading",
            };
        case types.FETCH_USER_ACCOUNTS_SUCEEDED:
            return {
                ...state,
                userAccounts: action.payload.data,
                fetchAccountState: "success",
            };
        case types.FETCH_USER_ACCOUNTS_FAILED:
            return {
                ...state,
                errorAccountMessage: action.payload,
                fetchAccountState: "failed",
            };
        case types.SET_ACCOUNT_TYPE:
            return {
                ...state,
                selectedAccount: action.payload,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };
        case types.SET_BUSINESS_NUMBERS:
            const previousLocalStorage = getState();
            setState({ ...previousLocalStorage, ...action.payload });
            return {
                ...state,
                user: { ...state.user, ...action.payload },
            };
        case types.FINISH_SIGNATORY_STEPS:
            return {
                ...state,
                isAuthenticated: true,
            };
        case types.FETCH_SME_PROFILES_STARTED:
            return {
                ...state,
                fetchSmeState: "loading",
                homeState: "loading",
            };
        case types.FETCH_SME_PROFILES_SUCCEEEDED:
            return {
                ...state,
                fetchSmeState: "success",
                smeAccounts: action.payload.groups,
                homeState: "success",
            };
        case types.FETCH_SME_PROFILES_FAILED:
            return {
                ...state,
                fetchSmeState: "failed",
                homeState: "failed",
            };
        case types.SET_IS_AUTHENTICATED:
            localStorage.setItem("isAuthenticated", JSON.stringify(true));
            return {
                ...state,
                isAuthenticated: true,
            };
        case types.SET_ACCOUNT_MODAL:
            return {
                ...state,
                showAccountSetupModal: action.payload,
            };
        case types.SET_PASSWORD_SHOW_MODAL:
            return {
                ...state,
                showPasswordSetModal: action.payload,
            };
        case types.SET_IS_ONBOARDED:
            return {
                ...state,
                isBeingOnboarded: action.payload,
            };
        case types.VALIDATE_KYC_STARTED:
            return {
                ...state,
                validateKycState: "loading",
            };
        case types.VALIDATE_KYC_SUCCEEEDED:
            return {
                ...state,
                validateKycState: "success",
                kycData: {
                    ...state.kycData,
                    tin: action.payload.doc_numbers.tin,
                    cac: action.payload.doc_numbers.cac,
                    company: action.payload.data.company,
                    email: action.payload.data.email,
                    address: action.payload.data.address,
                    registrationDate: action.payload.data.registrationDate,
                    secretary: action.payload.data.secretary,
                    branchOffice: action.payload.data.branchOffice,
                    lga: action.payload.data.lga,
                    objectives: action.payload.data.objectives,
                    activity: action.payload.data.activity,
                    registrationNo: action.payload.data.registrationNo,
                    city: action.payload.data.city,
                    name: action.payload.data.name,
                    shareholders: action.payload.data.shareholders,
                    typeofEntity: action.payload.data.typeofEntity,
                    directors: action.payload.data.directors,
                    state: action.payload.data.state,
                    headOffice: action.payload.data.headOffice,
                    country: action.payload.data.country,
                    isBusinessVerified: action.payload.isBusinessVerified
                },
            };
        case types.VALIDATE_KYC_FAILED:
            return {
                ...state,
                validateKycState: "failed",
            };
        case types.SET_KYC_ERROR_MODAL:
            return {
                ...state,
                kycErrorModal: action.payload,
            };
        case types.SET_COUNTRY:
            return {
                ...state,
                user: {
                    ...state.user,
                    country: action.payload,
                    updateFlag: "country",
                },
            };
        case types.SET_STATE_OBJ:
            return {
                ...state,
                user: {
                    ...state.user,
                    stateInfo: action.payload,
                    updateFlag: "state",
                },
            };
        case types.SET_LGA:
            return {
                ...state,
                user: {
                    ...state.user,
                    lga: action.payload.name,
                    updateFlag: "lga",
                },
            };
        case types.RESET_LGA:
            return {
                ...state,
                user: {
                    ...state.user,
                    lga: null,
                    stateInfo:{},
                    updateFlag: "lga",
                },
            };
        case types.SET_NEXT_OF_KIN_INFO:
            return {
                ...state,
                user: {
                    ...state.user,
                    nextOfKin: {
                        ...state.user.nextOfKin,
                        ...action.payload,
                    },
                    updateFlag:
                        action.payload?.updateFlag === "fullObj"
                            ? "nextOfKinObj"
                            : "nextOfKin",
                },
            };
        case types.SET_NOK_RELATIONSHIP:
            return {
                ...state,
                user: {
                    ...state.user,
                    nextOfKin: {
                        ...state.user.nextOfKin,
                        relationship: action.payload,
                    },
                    updateFlag: "nextOfKin",
                },
            };
        case types.UPLOAD_BILL_STARTED:
            return {
                ...state,
                uploadFileState: "loading",
            };
        case types.UPLOAD_BILL_SUCCEEEDED:
            return {
                ...state,
                uploadFileState: "success",
                user: {
                    ...state.user,
                    docs: {
                        ...state.user.docs,
                        [action.payload.name]: !action.payload.name
                            ? null
                            : action.payload.url,
                    },
                    updateFlag:
                        action.payload.name === "utilityBillFileUrl"
                            ? "utility"
                            : "resident",
                },
            };
        case types.UPLOAD_BILL_FAILED:
            return {
                ...state,
                uploadFileState: "failed",
            };
        case types.SET_CONFIRM_INFO:
            return {
                ...state,
                fromConfirmAccount: true,
                user: {
                    ...state.user,
                    street: action.payload.street,
                    landmark: action.payload.landmark,
                },
            };
        case types.SET_DOB:
            return {
                ...state,
                user: {
                    ...state.user,
                    dateOfBirth: action.payload,
                },
            };
        case types.SET_IS_ACCOUNT_SETUP:
            return {
                ...state,
                isAccountSetup: true,
            };
        case types.SET_NEW_ACCT_DETAILS:
            return {
                ...state,
                newAccountDetails: action.payload,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };
        case types.SELECTED_ACCT_TYPE:
            return {
                ...state,
                selectedAccountType: action.payload,
            };
        case types.BUSINESS_USER_EXISTS:
            return {
                ...state,
                businessUserExists: action.payload,
            }
        case types.VALIDATE_KYC_ONGOING:
            return {
                ...state,
                validateKycState: "success",
                kycData: {
                    ...state.kycData,
                    tin: action.payload.doc_numbers.tin,
                    cac: action.payload.doc_numbers.cac,
                    isBusinessVerified: false,
                },
            };
        case types.FIND_RETAIL_BUSINESS_SUCCEEDED:
            return {
                ...state,
                user: {
                    ...state.user,
                    firstName: action.payload.data.firstName,
                    middleName: action.payload.data.middleName,
                    lastName: action.payload.data.lastName
                }
            }
        case types.VALIDATE_USER_TOKEN_SUCCEEDED:
            return {
                ...state,
                signupToken: action.payload.token,
                signupEmail: action.payload.email,

            }
        case types.FROM_INVITE_PAGE:
            return{
                ...state,
                fromInvitePage: true
            }
        case types.NTB_VALIDATE_EMAIL_SUCCEEDED:
            return {
                ...state,
                ntbEmail: action.payload.ntbEmail,
                ntbPassword: action.payload.ntbPassword,
            }
        // case types.UPLOAD_VALID_ID_SUCCEEEDED:
        //     return {
        //         ...state,
        //         uploadFileState: "success",
        //         user: {
        //             ...state.user,
        //             docs: {
        //                 ...state.user.docs,
        //                 [action.payload.name]: !action.payload.name
        //                     ? null
        //                     : action.payload.url,
        //             },
        //         },
        //     };
        default:
            return state;
    }
};
